import { supabase } from "../../lib/supabase";

interface GoogleSignInButtonProps {
  text?: string;
}

export default function GoogleSignInButton({ text = "Sign in with Google" }: GoogleSignInButtonProps) {
  const login = async () => {
    // Preserve ?ref=CODE and UTM params through OAuth redirect.
    // Requires wildcard redirect URLs configured in Supabase dashboard.
    const redirectUrl = window.location.href;

    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: redirectUrl,
      },
    });
  };

  return (
    <button
      type="button"
      onClick={login}
      className="
        w-full flex items-center justify-center gap-3
        border border-gray-300 bg-white
        rounded-lg px-4 py-2
        text-sm font-medium text-gray-700
        hover:bg-gray-100 active:bg-gray-200
        transition-all
      "
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <img
          src='https://www.svgrepo.com/show/475656/google-color.svg'
          alt='google logo'
          className="w-5 h-5 object-contain"
        />
      </div>
      <span>{text}</span>
    </button>
  );
}
